export default [
  {
    text: 'Issue date',
    value: 'issue_date',
    apiSort: 'created_at',
  }, {
    text: 'Invoice ID',
    value: 'invoice_number',
  }, {
    text: 'Invoice period',
    value: 'invoice_period',
    apiSort: 'created_at',
  }, {
    text: 'Billing account',
    value: 'legal_business_name',
  }, {
    text: 'Platform',
    value: 'cost_center.platform',
    apiSort: 'cost_center',
  },{
    text: 'Amount',
    value: 'total_amount',
    align: 'right',
  }, {
    text: 'Actions',
    value: 'action',
    action: 'download',
    align: 'center',
    icon: 'file_download',
    sortable: false,
  }];
